import { Checkbox, Drawer, Link, Text } from '@servicetitan/anvil2';
import { useState } from 'react';
import { FinturfDisclosureText } from './FinturfDisclosureText';
import { TurnsDisclosureText } from './TurnsDisclosureText';
import {
    resolveSecondLookDisclosureText,
    useProviderConfig,
    useSecondLookIntegration,
    useSecondLookProviderName,
} from '@servicetitan/financing-workflow-shared';

export interface SecondLookCoapplicationDisclosureProps {
    onChange: (agreed: boolean) => void;
}

export const SecondLookCoapplicationDisclosure = ({
    onChange,
}: SecondLookCoapplicationDisclosureProps) => {
    const [showTerms, setShowTerms] = useState(false);
    const { turnsCoapplicationDisclosureText, firstLookLenderDisclosureName } = useProviderConfig();
    const { secondLookProvider } = useSecondLookIntegration();
    const secondLookProviderName = useSecondLookProviderName();
    const disclosureText = resolveSecondLookDisclosureText(
        turnsCoapplicationDisclosureText,
        secondLookProvider,
    );
    const isFinturfSecondLook = secondLookProvider?.toLowerCase() === 'finturf';

    if (isFinturfSecondLook) {
        return (
            <Checkbox
                aria-label="I agree to Finturf financing disclosures"
                label={
                    <FinturfDisclosureText firstLookLenderName={firstLookLenderDisclosureName} />
                }
                onChange={(e, state) => onChange(state?.checked ?? false)}
            />
        );
    }

    return (
        <>
            <Checkbox
                aria-label={`I agree to ${secondLookProviderName} financing terms`}
                label={
                    <Text>
                        {disclosureText}{' '}
                        <Link
                            onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                setShowTerms(true);
                            }}
                        >
                            View terms
                        </Link>
                    </Text>
                }
                onChange={(e, state) => onChange(state?.checked ?? false)}
            />
            {showTerms && (
                <Drawer open onClose={() => setShowTerms(false)}>
                    <Drawer.Header>{secondLookProviderName} Financing Terms</Drawer.Header>
                    <Drawer.Content>
                        <TurnsDisclosureText />
                    </Drawer.Content>
                </Drawer>
            )}
        </>
    );
};
